<div class="bg-base-100 border border-base-300 rounded-lg overflow-hidden h-full flex flex-col">
  <div class="px-4 py-3 border-b border-base-300 bg-base-200">
    <h3 class="text-sm font-bold text-primary uppercase tracking-wide mb-2">Templates</h3>
    <div class="join border border-base-300 rounded-none" role="tablist" aria-label="Validation rule kind">
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="selectedKind() === 'BASELINE'"
        (click)="selectKind('BASELINE')"
        [ngClass]="{
          'bg-info text-white': selectedKind() === 'BASELINE',
          'bg-base-100 text-primary hover:bg-base-200': selectedKind() !== 'BASELINE',
        }"
        class="join-item btn btn-xs rounded-none border-none"
      >
        Baseline
      </button>
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="selectedKind() === 'POST_ANALYSIS'"
        (click)="selectKind('POST_ANALYSIS')"
        [ngClass]="{
          'bg-info text-white': selectedKind() === 'POST_ANALYSIS',
          'bg-base-100 text-primary hover:bg-base-200': selectedKind() !== 'POST_ANALYSIS',
        }"
        class="join-item btn btn-xs rounded-none border-none"
      >
        Post-Analysis
      </button>
    </div>
  </div>
  <ul class="overflow-y-auto flex-1">
    <li *ngIf="loading()" class="px-4 py-6 text-center text-sm text-base-content/70">Loading...</li>
    <li
      *ngIf="!loading() && templates().length === 0"
      class="px-4 py-6 text-center text-sm text-base-content/70"
    >
      No templates in this scope.
    </li>
    <li *ngFor="let t of templates(); trackBy: trackById">
      <button
        type="button"
        (click)="select(t.id)"
        [class.bg-info]="selectedTemplateId() === t.id"
        [class.text-white]="selectedTemplateId() === t.id"
        [class.font-semibold]="selectedTemplateId() === t.id"
        class="w-full text-left px-4 py-3 text-sm text-primary hover:bg-base-200 transition-colors border-b border-base-300"
      >
        <div class="flex items-center justify-between">
          <span class="truncate">{{ t.name }}</span>
          <span
            *ngIf="countsByTemplateId().get(t.id) as counts"
            class="ml-2 text-xs whitespace-nowrap"
            [class.text-white]="selectedTemplateId() === t.id"
            [ngClass]="selectedTemplateId() !== t.id ? 'text-base-content/70' : ''"
          >
            {{ counts.field }}F / {{ counts.cross }}X
          </span>
        </div>
        <span
          class="inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-[11px] font-medium"
          [ngClass]="
            selectedTemplateId() === t.id
              ? 'bg-base-100/20 text-white'
              : 'bg-base-200 text-base-content/70'
          "
        >
          {{ fieldTypeLabel(t.data_type) }}
        </span>
      </button>
    </li>
  </ul>
</div>
